import styles from './gauge-chart-v2-tooltip.module.css';

type GaugeChartV2TooltipRow = {
  label: string;
  value: string;
};

type GaugeChartV2TooltipProps = {
  title?: string;
  value?: string;
  rows?: GaugeChartV2TooltipRow[];
};

export const GaugeChartV2Tooltip = ({
  title,
  value,
  rows = [],
}: GaugeChartV2TooltipProps) => (
  <div data-testid="gauge-chart-v2-tooltip">
    {title && <div className={styles.title}>{title}</div>}
    {value && <div className={styles.value}>{value}</div>}
    {rows.length > 0 && (
      <div className={styles.rows}>
        {rows.map((row) => (
          <div key={row.label} className={styles.row}>
            <span>{row.label}</span>
            <span>{row.value}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);
